module.exports = "<svg preserveAspectRatio=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 344 344\" >\n    <g id=\"Rectangle\" transform=\"translate(172.000000, 172.000000) rotate(-90.000000) translate(-172.000000, -172.000000) \">\n        <polygon id=\"Shape\"  points=\"0 0 344 0 172 172 0 344\"></polygon>\n    </g>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shapes/triangleBottomLeft.svg
// module id = 2834
// module chunks = 0